<template>
  <div class="choice-container" ref="container">
    <span
      @click="open"
      class="choice"
      ref="choice"
    >
      <slot
        name="choice"
        v-bind="{ choice: value }"
      >
        {{ value }}
      </slot>
    </span>

    <ul
      ref="menu"
      :class="menuClass"
      :style="menuStyle"
    >
      <li
        v-for="(option, key) in options" 
        :key="key"
        class="option"
        ref="option"
        @click="handleChoice(option)"
      >
        <slot
          name="option"
          v-bind="{ choice: option }"
        >
          {{ option }}
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'Choice',

  props: {
    value: {},
    options: { type: Array }
  },

  data () {
    return {
      isOpen: false,
      isMounted: false
    }
  },

  methods: {
    open () {
      this.isOpen = true
    },

    close () {
      this.isOpen = false
    },
  
    handleChoice (choice) {
      this.$emit('input', choice)

      this.close()
    }
  },

  computed: {
    menuStyle () {
      if (!this.isMounted || !this.isOpen) return

      const choiceIndex = this.options.findIndex(
        option => option === this.value
      )

      const menuRect = this.$refs.menu.getBoundingClientRect()

      const choiceRect = this.$refs.choice.getBoundingClientRect()

      const chosenOptionRect = this.$refs.option[choiceIndex].getBoundingClientRect()

      const top =
        menuRect.top - (
            chosenOptionRect.top
          + chosenOptionRect.height / 2 
        ) + choiceRect.height / 2

      const left =
        menuRect.left - (
            chosenOptionRect.left
          + chosenOptionRect.width / 2
        ) + choiceRect.width / 2

      return { top: `${top}px`, left: `${left}px` }
    },

    menuClass () {
      return [
        'menu',
        { 'menu-open': this.isOpen }
      ]
    }
  },

  mounted () {
    this.isMounted = true
  }
}

</script>

<style>
  .choice-container {
    box-sizing: border-box;
    position: relative;
    display: inline-block;
  }

  .menu {
    background: #fff;
    border: 1px solid #ddd;
    max-height: 400px;
    overflow: scroll;
    z-index: 10;
    padding: 0;
    visibility: hidden;
    position: absolute;
  }

  .menu-open {
    visibility: visible;
  }

  .choice {
    display: inline-block;
    cursor: pointer;
  }

  .option {
    cursor: pointer;
    padding: 8px 16px;
    border-bottom: 1px solid #ddd;
  }

  .option:hover {
    @apply
      bg-dull-light
  }

  .option:last-child {
    border: none;
  }
</style>
